// LogoutButton.jsx
// Create this as a separate component

import React from "react";
import { useDispatch } from "react-redux";
import { clearUser } from "../../../state/reducers/userSlice"; // adjust path as needed

const LogoutButton = () => {
  const dispatch = useDispatch();

  const handleLogout = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    // Clear user from Redux
    dispatch(clearUser());

    // Clear token
    localStorage.removeItem("token");

    // Force a hard redirect to the login page
    window.location.href = "/login";
  };

  return (
    <button
      className="block w-full px-4 py-3 text-left text-sm text-red-600 hover:bg-gray-100"
      onClick={handleLogout}
      style={{ zIndex: 10000 }}
    >
      Logout
    </button>
  );
};

export default LogoutButton;
